import Card from "components/card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CardOverview = ({
    title,
    value,
    icon,
    color,
    months,
    years,
    onClick,
    className,
}) => {
    const getCardStyle = () => {
        switch (color) {
            case "primary":
                return "bg-gradient-to-br from-primary-800 to-primary-500 text-white shadow-md";

            case "brand":
                return "bg-gradient-to-br from-brand-700 to-brand-400 text-white shadow-md";

            case "danger":
                return "bg-gradient-to-br from-red-700 to-red-400 text-white shadow-md";

            case "warning":
                return "bg-gradient-to-br from-orange-600 to-amber-400 text-white shadow-md";

            case "light-warning":
                return "bg-gradient-to-br from-amber-500 to-yellow-400 text-white/90 shadow-md";

            default:
                return "bg-gray-100 text-gray-800";
        }
    };

    const getIconStyle = () => {
        switch (color) {
            case "primary":
                return "text-primary-800";

            case "brand":
                return "text-brand-700";

            case "danger":
                return "text-red-700";

            case "warning":
                return "text-orange-600";

            case "light-warning":
                return "text-yellow-600";

            default:
                return "text-gray-500";
        }
    };

    return (
        <Card
            extra={`px-3 md:px-4 py-2 md:py-3 !shadow-md rounded-[2.2rem] transition ${
                color ? getCardStyle() : ""
            } ${className ?? ""} ${
                onClick ? "cursor-pointer hover:scale-[1.02]" : ""
            }`}
        >
            <div
                className="flex items-center gap-5"
                onClick={() => onClick?.()}
            >
                <div className="bg-radial-white flex h-12 w-12 select-none flex-col items-center justify-center gap-0 rounded-full">
                    <FontAwesomeIcon
                        className={`h-5 ${getIconStyle()} ${
                            months ? "!h-[1rem]" : ""
                        }`}
                        icon={icon}
                    />

                    {months && (
                        <span
                            className={`text-xs font-semibold ${getIconStyle()}`}
                        >
                            {months === 1 ? "mese" : "mesi"}
                        </span>
                    )}

                    {years && (
                        <span
                            className={`text-xs font-semibold ${getIconStyle()}`}
                        >
                            {years === 1 ? "anno" : "anni"}
                        </span>
                    )}
                </div>

                <div className="flex flex-col gap-1">
                    <div className="flex w-full items-center">
                        <h5 className="whitespace-nowrap text-[20px] font-semibold">
                            {title}
                        </h5>
                    </div>

                    <div className="flex h-full w-full items-center">
                        <span className="text-4xl font-semibold">{value}</span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default CardOverview;
